import { component } from 'picoapp';
import toggleAddToCartBtn from '../../../js/lib/add-to-cart-btn';
import { addVariant } from '../../../js/lib/cart';
import { handleize } from '../../../js/lib/strings';
import Drawer from '../../../js/utils/drawer';
import { clear } from '../../../js/utils/node';

export default component(async (node, ctx) => {
  /**
   * Data + elements
   */
  const BIS = node.querySelectorAll('.js-klaviyoBIS');
  const brandSizeTableSelect = node.querySelector('.js-brandSizeTableSelect');
  const brandSizeTables = node.querySelectorAll('.js-brandSizeTable');
  const compareAtPrice = node.querySelector('.js-compareAtPrice');
  const fitInfoBtn = node.querySelector('.js-fitInfoBtn');
  const fitInfoContainer = node.querySelector('.js-fitInfoContainer');
  const fitSelectionBtn = node.querySelector('.js-fitSelectionBtn');
  const fitSizeAddToCartBtn = node.querySelector('.js-fitSizeAddToCartBtn');
  const fitSizeSelectionBtn = node.querySelector('.js-fitSizeSelectionBtn');
  const fitSizeSelectionDrawer = node.querySelector('.js-fitSizeSelectionDrawer');
  const fitSizeSelectionDrawerCloseBtn = node.querySelector('.js-fitSizeSelectionDrawerCloseBtn');
  const fitValueBtns = node.querySelectorAll('.js-fitValueBtn');
  const form = node.querySelector('.js-form');
  const formAddToCartBtn = node.querySelector('.js-formAddToCartBtn');
  const lengthSelectionContainer = node.querySelector('.js-lengthSelectionContainer');
  const lengthValueBtns = node.querySelectorAll('.js-lengthValueBtn');
  const lengthValueBtnList = node.querySelectorAll('.js-lengthValueBtnListItem');
  const lengthValueTexts = node.querySelectorAll('.js-lengthValueText');
  const mouseOverChange = node.querySelectorAll('.js-mouseOverChange');
  const linkVariantName = node.querySelector('.js-linkVariantName');
  const mobileCta = node.querySelector('.js-mobileCta');
  const price = node.querySelector('.js-price');
  const redirectGen = node.querySelector('.js-RedirectGen');
  const reselectFlow = node.querySelector('.js-reselectFlow');
  const selectedFit = node.querySelector('.js-selectedFit');
  const selectedFitAndSize = node.querySelector('.js-selectedFitAndSize');
  const sizeGuideAddToCartBtns = node.querySelectorAll('.js-sizeGuideAddToCartBtn');
  const sizeGuideBtns = node.querySelectorAll('.js-sizeGuideBtn');
  const sizeGuideDrawer = node.querySelector('.js-sizeGuideDrawer');
  const sizeGuideDrawerCloseBtn = node.querySelector('.js-sizeGuideDrawerCloseBtn');
  const sizeGuideFitGroups = node.querySelectorAll('.js-sizeGuideFitGroup');
  const sizeGuideFitSelect = node.querySelector('.js-sizeGuideFitSelect');
  const sizeGuideTooltipBtns = node.querySelectorAll('.js-sizeGuideTooltipBtn');
  const sizeGuideTooltips = node.querySelectorAll('.js-sizeGuideTooltip');
  const storeTooltipsBtns = node.querySelectorAll('.js-storeTooltipBtn');
  const storeTooltips = node.querySelectorAll('.js-storeTooltip');
  const sizeSelectionBtn = node.querySelector('.js-sizeSelectionBtn');
  const sizeSelectionContainer = node.querySelector('.js-sizeSelectionContainer');
  const sizeSelectionList = node.querySelector('.js-sizeSelectionList');
  const stockInfo = node.querySelectorAll('.js-stockInfo');
  const stockInfoPickup = node.querySelectorAll('.js-stockInfo-pickup');
  const thumbnailBtns = node.querySelectorAll('.js-thumbnailBtn');
  const thumbnailDrawer = node.querySelector('.js-thumbnailDrawer');
  const thumbnailDrawerCloseBtn = node.querySelector('.js-thumbnailDrawerCloseBtn');
  const variantSelect = node.querySelector('.js-variantSelect');

  const productData = JSON.parse(node.querySelector('.js-productData').innerHTML);
  const variantData = JSON.parse(node.querySelector('.js-variantData').innerHTML);

  const config = JSON.parse(node.dataset.config);
  const {
    fitOptionPosition,
    sizeOptionPosition,
    lengthOptionPosition,
    stockWarningLimit,
    collectionHandle,
    lengthOptionDefault,
    isProductEvent,
    prelaunch,
  } = config;

  const strings = window.theme.strings.product;

  const updateBackInStock = ({ available }) => {
    if (!BIS) return false;

    BIS.forEach((btn) => {
      btn.hidden = available;
    });

    return true;
  };

  const updateAddToCartBtn = (variant) => {
    const { available } = variant;

    if (new URLSearchParams(window.location.search).get('variant')) {
      // formAddToCartBtn.disabled = !available;
      fitSizeAddToCartBtn.disabled = !available;
      fitSizeAddToCartBtn.hidden = !available;
    } else {
      fitSizeAddToCartBtn.disabled = true;
      fitSizeAddToCartBtn.hidden = true;
    }
  };

  const findGen = (string, type) => string.split(':')[0] === type.split(':')[0];
  const arrayIsEqual = (a, b) => a.every((item) => b.includes(item))
    && b.every((item) => a.includes(item));

  const findMatchingVariant = (data, variant, type) => {
    let matchingVariant = false;
    const { options } = variant;
    const typeMatch = data.filter((item) => item.handle !== productData.handle
      && findGen(item.tag, type));

    const findVariantItem = typeMatch
      .find((item) => item.variants.filter((v) => arrayIsEqual(v.options, options)));

    // eslint-disable-next-line no-shadow,consistent-return
    findVariantItem.variants.forEach((variant) => {
      if (variant.available && arrayIsEqual(variant.options, options)) {
        matchingVariant = variant;
        return false;
      }
    });

    return matchingVariant;
  };

  const fetchData = async () => {
    const url = new URL(window.theme.routes.collectionsAll, window.location.origin);
    url.searchParams.set('view', 'data');

    return fetch(url.toString(), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => data);
  };

  const updateRedirectGen = (variant) => {
    const { available } = variant;

    if (available) {
      redirectGen.hidden = true;
      return;
    }

    const { type } = redirectGen.dataset;

    if (sessionStorage.getItem('redirectGen')) {
      const redirectGenParse = JSON.parse(sessionStorage.getItem('redirectGen'));
      const url = findMatchingVariant(redirectGenParse, variant, type);
      if (url) {
        redirectGen.href = url.url;
        redirectGen.hidden = false;
      } else {
        redirectGen.hidden = true;
      }
    } else {
      fetchData().then((data) => {
        sessionStorage.setItem('redirectGen', JSON.stringify(data));
        const url = findMatchingVariant(data, variant, type);
        if (url) {
          redirectGen.href = url.url;
          redirectGen.hidden = false;
        } else {
          redirectGen.hidden = true;
        }
      });
    }
  };

  /**
   * Functions
   */

  const displayFitInfo = () => {
    fitInfoContainer.classList.toggle('product__fit-info--active');
  };

  const initSwatches = () => {
    mouseOverChange.forEach((swatch) => {
      // Show swatch title on mouse enter
      swatch.addEventListener('mouseenter', () => {
        const { name } = swatch.dataset;
        linkVariantName.textContent = name;
      });

      // Switch back to current title on mouse leave
      swatch.addEventListener('mouseleave', () => {
        linkVariantName.textContent = linkVariantName.dataset.initialName;
      });
    });
  };

  const getVariantInventoryQuantity = (variant) => {
    if (variant.inventory_quantity) {
      return variant.inventory_quantity;
    }

    const { inventoryQuantity } = variantData.find((v) => v.id === variant.id);
    return inventoryQuantity;
  };

  const updateStockInfo = (variant, inventory) => {
    let pickupStoreLevel, onlineStoreLevel;
    let onlyOneStore = false;
    inventory.forEach((inventoryVariant) => {
      if (inventoryVariant.id.includes(variant.id)) {
        const warehouseInventory = inventoryVariant?.inventory_quantities?.find((i) => i.name.includes("Warehouse"));
        onlineStoreLevel = warehouseInventory?.level;
        if (inventoryVariant.inventory_quantities.length == 1) {
          onlyOneStore = true;
        } else {
          const pickupInventory = inventoryVariant?.inventory_quantities?.find((i) => i.name.includes("Pilestræde"));
          pickupStoreLevel = pickupInventory?.level;
        }
      }
    })

    replaceAvailabilityText(stockInfo, onlineStoreLevel, strings, false); // online store

    if (onlyOneStore) {
      stockInfoPickup.forEach(stockInfoNode => {
        stockInfoNode.style.display = "none";
      });
      return;
    }

    stockInfoPickup.forEach(stockInfoNode => {
      if (!pickupStoreLevel) {
        stockInfoNode.classList.add("hidden");
      } else {
        stockInfoNode.classList.remove("hidden");
      }
    })

    const availabilityStrings = {
      inStock: strings.inStockStore,
      soldOut: strings.soldOutStore,
      stockWarning: strings.stockWarningStore
    }

    replaceAvailabilityText(stockInfoPickup, pickupStoreLevel, availabilityStrings, true);

    function replaceAvailabilityText(container, inventoryQuantity, availabilityStrings, useSpan) {
      const soldOut = inventoryQuantity <= 0;
      const warn = inventoryQuantity <= stockWarningLimit;

      container.forEach((info) => {
        if (soldOut) {
          info.classList.remove('text-orange', 'text-green');
          info.classList.add('text-red');
        } else {
          info.classList.remove('text-red');
          info.classList[warn ? 'add' : 'remove']('text-orange');
          info.classList[warn ? 'remove' : 'add']('text-green');
        }
        let text = availabilityStrings.inStock;
        if (soldOut) {
          text = availabilityStrings.soldOut;
        } else if (warn) {
          text = availabilityStrings.stockWarning.replace('%quantity%', inventoryQuantity);
        }

        let infoText = info;
        if (useSpan) {
          infoText = info.querySelector("span");
        }

        infoText.innerHTML = `<div class="w-[14px] h-[14px] rounded-full bg-current"></div>
          <p class="text-black stock-text">${text}</p>`;
      })
    }
  };

  async function getInventory(productData) {
    const storeLang = window.theme.storeUrl.split('.')[window.theme.storeUrl.split('.').length - 1];
    const storeMap = {
      'se': 'barons-swe',
      'nl': 'barons-nl',
      'no': 'barons-no',
      'dk': 'barons-dk',
      'com': 'barons-dk'
    };

    const productId = productData.id;
    const variantCount = productData.variants.length;
    const inventoryEndpoint = `https://netlify.blacklemon.dk/.netlify/functions/getProductInventoryLevels?store=${storeMap[storeLang]}&prodId=${productId}&variantCount=${variantCount}`;

    try {
      const inventory = await fetch(inventoryEndpoint);
      const inventoryData = await inventory.json();
      return inventoryData;
    } catch (error) {
      console.error('Error fetching inventory', error);
    }
  }

  async function initVariantSelection() {

    const inventory = await getInventory(productData);
    const selectedVariantCallback = (variant) => {
      if (variant) {
        if (compareAtPrice) {
          if (variant.compare_at_price > variant.price) {
            compareAtPrice.textContent = Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat); // eslint-disable-line
          } else {
            compareAtPrice.textContent = '';
          }
        }

        price.textContent = Shopify.formatMoney(variant.price, theme.moneyFormat);
        updateAddToCartBtn(variant);
        updateBackInStock(variant);

        const variantURL = new URLSearchParams(window.location.search).get('variant');
        if (variantURL) {
          updateStockInfo(variant, inventory);
        }

        if (redirectGen) {
          updateRedirectGen(variant);
        }

      }
    };

    const createShopifySelection = () => new Shopify.OptionSelectors(`product-${productData.id}`, {
      product: productData,
      onVariantSelected: selectedVariantCallback,
      enableHistoryState: true,
    });

    createShopifySelection();
  };

  const initOptionSelection = () => {
    // Append drawer to body to reset z-index and position
    document.body.appendChild(fitSizeSelectionDrawer);
    const drawer = Drawer(fitSizeSelectionDrawer);
    fitSizeSelectionBtn.addEventListener('click',  (e) => {
      e.stopPropagation();
      drawer.open();
    });
       fitSizeSelectionDrawer.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    fitSizeSelectionDrawerCloseBtn.addEventListener('click', () => drawer.close());
    sizeGuideBtns.forEach((btn) => {
      btn.addEventListener('click', () => drawer.close());
    });

    const trueOptionSelectors = node.querySelectorAll('.single-option-selector');
    const trueFitSelector = Array.from(trueOptionSelectors).find((selector) => parseInt(selector.dataset.option.replace('option', ''), 10) === fitOptionPosition);
    const trueSizeSelector = Array.from(trueOptionSelectors).find((selector) => parseInt(selector.dataset.option.replace('option', ''), 10) === sizeOptionPosition);
    const trueLengthSelector = Array.from(trueOptionSelectors).find((selector) => parseInt(selector.dataset.option.replace('option', ''), 10) === lengthOptionPosition);

    // Handle fit change to update available sizes and lengths
    if (trueFitSelector) {
      trueFitSelector.addEventListener('change', () => {

        // Show length selection if the new fit has multiple lengths
        if (trueLengthSelector) {
          const hasMultipleLengths = new Set(fitVariants.map(v => v[`option${lengthOptionPosition}`])).size > 1;
          if (hasMultipleLengths) {
            lengthSelectionContainer.classList.remove('hidden');
            // Don't reset length value, let the user choose
          } else {
            lengthSelectionContainer.classList.add('hidden');
            // set length to standard if only one length option
            trueLengthSelector.value = "Standard";
            localStorage.setItem('selectedLength', 'Standard');
            trueLengthSelector.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    }

    const selectSize = (btn) => {
      const { value } = btn.dataset;

      trueSizeSelector.value = value;
      trueOptionSelectors.forEach((selector) => selector.dispatchEvent(new Event('change', { bubbles: true })));

      const sizeValueBtns = sizeSelectionList.querySelectorAll('.js-sizeValueBtn');

      sizeValueBtns.forEach((sizeValueBtn) => {
        sizeValueBtn.classList[sizeValueBtn === btn ? 'add' : 'remove']('product__size-value-button--active');
      });

      selectedFitAndSize.textContent = `${trueFitSelector.value} ${trueSizeSelector.value} ${trueLengthSelector ? trueLengthSelector.value : ''}`;


      localStorage.setItem('selectedSize', value);
    };

    const updateSizeSelection = () => {
      const selectedFitValue = trueFitSelector.value;
      let matchingVariants = [];

      // First get all variants for the selected fit
      const fitVariants = window.theme.hasFit
        ? productData.variants.filter((variant) => variant[`option${fitOptionPosition}`] === selectedFitValue)
        : productData.variants;

      // Check if the fit has multiple lengths
      const hasMultipleLengths = new Set(fitVariants.map(v => v[`option${lengthOptionPosition}`])).size > 1;

      if (trueLengthSelector && hasMultipleLengths) {
        const selectedLengthValue = trueLengthSelector.value;
        matchingVariants = fitVariants.filter(variant => variant[`option${lengthOptionPosition}`] === selectedLengthValue);
      } else {
        // If no length selector or fit doesn't have multiple lengths, use all variants for the fit
        matchingVariants = fitVariants;
      }

      const uniqueMatchingVariants = [...new Map(matchingVariants.map((item) => [item[`option${sizeOptionPosition}`], item])).values()];
      const currVariant = new URLSearchParams(window.location.search).get('variant') || '';
      let isDefaultVariantSelected = false;

      sizeSelectionList.innerHTML = uniqueMatchingVariants.map((variant, index) => {
        const { inventoryQuantity } = variantData.find((v) => v.id === variant.id);
        const borderClass = index < uniqueMatchingVariants.length - 1 ? 'border-b border-grey-200' : '';
        const colorClass = !variant.available ? 'text-grey-200' : '';
        const sizeClass = !variant.available ? 'line-through' : '';
        const activeClass = 'product__size-value-button--active';
        const currentClass = variant.id.toString() === currVariant ? activeClass : '';
        let isDefaultAvailVariant = false;

        isDefaultAvailVariant = false;
        isDefaultVariantSelected = false;

        return `<li class="${borderClass} ${colorClass}">
          <button type="button" class="product__size-value-button js-sizeValueBtn ${isDefaultAvailVariant ? activeClass : currentClass}" data-value="${variant[`option${sizeOptionPosition}`]}" data-quantity="${inventoryQuantity}">
            <span class="${sizeClass}">${variant[`option${sizeOptionPosition}`]}</span>
            ${(() => {
            if (inventoryQuantity <= 0) {
              return `<span class="product__size-value-button__stock-info font-normal text-grey-500">${strings.getNotified}</span>`;
            }

            return '';
          })()}
          </button>
        </li>`;
        /* eslint-enable */
      }).join('');

      const sizeValueBtns = sizeSelectionList.querySelectorAll('.js-sizeValueBtn');

      sizeValueBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          selectSize(btn);

          const matchingFitSizeVariant = productData.variants.filter((variant) => variant.option1 === localStorage.getItem('selectedFit') && variant.option2 === localStorage.getItem('selectedSize'));
          localStorage.removeItem('selectedLength');

          if (localStorage.getItem('selectedSize') !== null && trueLengthSelector) {
            if (matchingFitSizeVariant.length === 1) {
              lengthSelectionContainer.classList.add('hidden');
            } else {
              lengthSelectionContainer.classList.remove('hidden');
            }
          }

          lengthValueTexts.forEach((lengthValueText) => {
            const matchingLengthVariant = matchingFitSizeVariant
              .find((variant) => variant.option3
                === lengthValueText.textContent && variant.available);

            lengthValueText.classList[matchingLengthVariant ? 'remove' : 'add']('line-through');
          });

          lengthValueBtnList.forEach((lengthValueBtn) => {
            const matchingLengthVariant = matchingFitSizeVariant
              .find((variant) => variant.option3 === lengthValueBtn.dataset.lengthValue);

            lengthValueBtn.classList[matchingLengthVariant ? 'remove' : 'add']('hidden');

            lengthValueBtn.classList[matchingFitSizeVariant.length === 1 ? 'add' : 'remove']('w-full');
            lengthValueBtn.classList[matchingFitSizeVariant.length === 2 ? 'add' : 'remove']('w-1/2');
            lengthValueBtn.classList[matchingFitSizeVariant.length === 3 ? 'add' : 'remove']('w-1/3');

            lengthValueBtn.children[0].classList[matchingFitSizeVariant.length === 2 ? 'add' : 'remove']('aspect-ratio--3/2');
            lengthValueBtn.children[0].classList[matchingFitSizeVariant.length === 3 ? 'add' : 'remove']('aspect-ratio--1/1');
          });

          // If only one length value is visible, select it
          const visibleLengthValueBtns = Object.values(lengthValueBtnList).filter((btn) => !btn.classList.contains('hidden'));
          if (visibleLengthValueBtns.length == 1) {
            visibleLengthValueBtns[0].click();
          }

          reselectFlow.classList.add('hidden');
          reselectFlow.classList.remove('flex');

          stockInfo.forEach((info) => {
            info.classList.remove('hidden');
          });
          stockInfoPickup.forEach((info) => {
            info.classList.remove('hidden');
          });
        });

        if (localStorage.getItem('selectedSize') === btn.dataset.value && localStorage.getItem('selectedFit') === selectedFit.textContent) {
          btn.click();
        }

        if (localStorage.getItem('selectedSize') !== null) {
          lengthSelectionContainer.classList.remove('hidden');
        }
      });
    };

    const selectLength = (btn) => {
      const { value } = btn.dataset;

      trueLengthSelector.value = value;
      trueOptionSelectors.forEach((selector) => selector.dispatchEvent(new Event('change', { bubbles: true })));

      lengthValueBtns.forEach((lengthValueBtn) => {
        lengthValueBtn.classList[lengthValueBtn === btn ? 'add' : 'remove']('product__length-value-button--active');
      });

      localStorage.setItem('selectedLength', value);
    };

    const updateLengthSelection = () => {
      lengthValueBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          selectLength(btn);
          updateSizeSelection();

          // find the sizeValueBtns that matches the selected size
          const currentSizeValueBtns = sizeSelectionList.querySelectorAll('.js-sizeValueBtn');
          const matchingSizeValueBtn = Array.from(currentSizeValueBtns).find((sizeValueBtn) => sizeValueBtn.dataset.value === localStorage.getItem('selectedSize'));

          if (matchingSizeValueBtn) {
            reselectFlow.classList.add('hidden');
            reselectFlow.classList.remove('flex');

            stockInfo.forEach((info) => {
              info.classList.remove('hidden');
            });
            stockInfoPickup.forEach((info) => {
              info.classList.remove('hidden');
            });

            if (matchingSizeValueBtn.dataset.quantity <= '0') {
              fitSizeAddToCartBtn.hidden = true;
            } else {
              fitSizeAddToCartBtn.hidden = false;
            }
          } else {
            reselectFlow.classList.add('flex');
            reselectFlow.classList.remove('hidden');

            stockInfo.forEach((info) => {
              info.classList.add('hidden');
            });


            stockInfoPickup.forEach((info) => {
              info.classList.add('hidden');
            });

            fitSizeAddToCartBtn.hidden = true;
          }
        });

        // Clicks on standard every time and redirects from any other length variant
        // if (localStorage.getItem('selectedLength') === null && btn.dataset.value === lengthOptionDefault) {
        //   btn.click();
        // }

        if (localStorage.getItem('selectedLength') === lengthOptionDefault && btn.dataset.value === lengthOptionDefault) {
          btn.click();
        }
      });
    };

    const removeVariantURLParam = () => {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(window.location.search);

      params.delete('variant');
      url.search = params;

      // window.history.replaceState(null, '', url);
    };

    const selectFit = (btn) => {
      const { value } = btn.dataset;

      trueFitSelector.value = value;
      selectedFit.textContent = strings.selectedFit.replace('%fit%', value);

      fitValueBtns.forEach((fitValueBtn) => {
        fitValueBtn.classList[fitValueBtn === btn ? 'add' : 'remove']('product__fit-value-button--active');
      });

      // Get all variants for the new fit
      const newFitVariants = productData.variants.filter(
        variant => variant[`option${fitOptionPosition}`] === value
      );

      // Check if the new fit has multiple lengths
      const newFitLengths = [...new Set(newFitVariants.map(v => v[`option${lengthOptionPosition}`]))];
      const hasMultipleLengths = newFitLengths.length > 1;

      // Reset length selection if the new fit has multiple lengths
      if (trueLengthSelector) {
        if (hasMultipleLengths) {
          // If the current length is not available in the new fit, reset it to the first available length
          const currentLength = trueLengthSelector.value;
          if (!newFitLengths.includes(currentLength)) {
            const defaultLength = newFitLengths[0];
            trueLengthSelector.value = defaultLength;
            localStorage.setItem('selectedLength', defaultLength);
          }
          lengthSelectionContainer.classList.remove('hidden');
        } else {
          // If the new fit has only one length, hide the length selector
          lengthSelectionContainer.classList.add('hidden');
          trueLengthSelector.value = "Standard";
          localStorage.setItem('selectedLength', 'Standard');
          trueLengthSelector.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      updateSizeSelection();
      updateLengthSelection();

      setTimeout(() => {
        fitSelectionBtn.click();
      }, 300);

      sizeSelectionBtn.disabled = false;

      if (!sizeSelectionBtn.classList.contains('harmonica-item__button--active')) {
        sizeSelectionBtn.click();
      }

      removeVariantURLParam();
      clear(stockInfo);
      clear(stockInfoPickup);

      selectedFitAndSize.textContent = theme.has_fit ? strings.selectFitAndSize : strings.selectedSize;
      localStorage.setItem('selectedFit', value);
    };

    fitValueBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        localStorage.removeItem('selectedLength');
        selectFit(btn);

        if (localStorage.getItem('selectedFit') !== null) {
          sizeSelectionContainer.classList.remove('hidden');
        }

        if (!trueLengthSelector) {
          lengthSelectionContainer.classList.add('hidden');
        }

        lengthSelectionContainer.classList.add('hidden');

        fitSizeAddToCartBtn.hidden = true;
        BIS.forEach((bisBtn) => {
          bisBtn.hidden = true;
        });
        reselectFlow.classList.remove('hidden');
        reselectFlow.classList.add('flex');

        stockInfo.forEach((info) => {
          info.classList.add('hidden');
        });
        stockInfoPickup.forEach((info) => {
          info.classList.add('hidden');
        });
      });

      if (!trueLengthSelector) {
        lengthSelectionContainer.classList.add('hidden');
      }

      if (localStorage.getItem('selectedFit') !== null) {
        sizeSelectionContainer.classList.remove('hidden');
      }

      if (fitValueBtns.length === 1) {
        btn.click();
      }
    });

    const updateSelectionFromVariantParam = () => {
      const params = new URLSearchParams(window.location.search);
      const variantParam = parseInt(params.get('variant'), 10);

      if (variantParam) {
        const variant = productData.variants.find((v) => v.id === variantParam);
        const fit = variant[`option${fitOptionPosition}`];
        const size = variant[`option${sizeOptionPosition}`];
        const length = variant[`option${lengthOptionPosition}`];

        const matchingFitValueBtn = Array.from(fitValueBtns).find((btn) => btn.dataset.value === fit);; // eslint-disable-line
        matchingFitValueBtn.click();

        const matchingSizeValueBtn = Array.from(sizeSelectionList.querySelectorAll('.js-sizeValueBtn')).find((btn) => btn.dataset.value === size);
        matchingSizeValueBtn.click();

        if (length) {
          const matchingLengthValueBtn = Array.from(lengthValueBtns)
            .find((btn) => btn.dataset.value === length);
          matchingLengthValueBtn.click();
        }
      }
    };

    updateSelectionFromVariantParam();

    fitSizeAddToCartBtn.addEventListener('click', () => formAddToCartBtn.click());
  };

  const preselectOptions = () => {
    // Preselect fit if within a fit collection
    fitValueBtns.forEach((fitValueBtn) => {
      const { value } = fitValueBtn.dataset;
      const valueHandleized = handleize(value);

      if (valueHandleized === collectionHandle) {
        fitValueBtn.click();
      }
    });

    // Preselect fit if already previously selected by user
    fitValueBtns.forEach((fitValueBtn) => {
      const { value } = fitValueBtn.dataset;

      if (localStorage.getItem('selectedFit') === value) {
        fitValueBtn.click();
      }
    });

    // Preselect size if already previously selected by user 
    const sizeValueBtns = sizeSelectionList.querySelectorAll('.js-sizeValueBtn');

    sizeValueBtns.forEach((sizeValueBtn) => {
      const { value } = sizeValueBtn.dataset;

      if (localStorage.getItem('selectedSize') === value) {
        sizeValueBtn.click();
      }
    });
  };

  const toggleAllAddToCartBtns = (active) => {
    [...sizeGuideAddToCartBtns, formAddToCartBtn, fitSizeAddToCartBtn].forEach((btn) => {
      toggleAddToCartBtn(btn, active);
    });
  };

  const initThumbnailDrawer = () => {
    if (thumbnailDrawer) {
      document.body.appendChild(thumbnailDrawer);
      const drawer = Drawer(thumbnailDrawer);
       thumbnailBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          drawer.open();
        });
      });
      thumbnailDrawer.addEventListener('click', (e) => {
        e.stopPropagation();
      });
      thumbnailDrawerCloseBtn.addEventListener('click', () => drawer.close());
    }
  };

  const initSizeGuide = () => {
    document.body.appendChild(sizeGuideDrawer);
    const drawer = Drawer(sizeGuideDrawer);
    sizeGuideBtns.forEach((btn) => {
      btn.addEventListener('click',  (e) => {
          e.stopPropagation();
          drawer.open();
        } );
    });
     sizeGuideDrawer.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    sizeGuideDrawerCloseBtn.addEventListener('click', () => drawer.close());
    sizeGuideFitSelect.addEventListener('change', () => {
      sizeGuideFitGroups.forEach((group) => {
        group.hidden = group.dataset.fit !== sizeGuideFitSelect.value;
      });
    });

    sizeGuideAddToCartBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        // Temporarily set variant select value, fake click on form submit, then switch back
        const { variantId } = btn.dataset;
        const previousVariantId = variantSelect.value;
        // const wasDisabled = formAddToCartBtn.disabled;

        variantSelect.value = variantId;
        // formAddToCartBtn.disabled = false;
        formAddToCartBtn.click();
        variantSelect.value = previousVariantId;
        // formAddToCartBtn.disabled = wasDisabled;
      });
    });

    brandSizeTableSelect.addEventListener('change', () => {
      brandSizeTables.forEach((table) => {
        table.hidden = table.dataset.brandName !== brandSizeTableSelect.value;
      });
    });
  };

  const initSizeGuideTooltips = () => {
    const openTooltip = (tooltip) => {
      tooltip.hidden = false;

      const rect = tooltip.getBoundingClientRect();

      if (rect.left + rect.width > window.innerWidth) {
        tooltip.classList.add('product__size-guide__tooltip--right');
      }
    };

    const closeTooltip = (tooltip) => {
      tooltip.hidden = true;
      tooltip.classList.remove('product__size-guide__tooltip--right');
    };

    sizeGuideTooltipBtns.forEach((btn) => {
      const { index } = btn.dataset;
      const matchingTooltip = Array.from(sizeGuideTooltips).find((tooltip) => (
        tooltip.dataset.index === index
      ));

      btn.addEventListener('click', () => {
        openTooltip(matchingTooltip);
      });

      window.addEventListener('click', (event) => {
        if (!matchingTooltip.contains(event.target) && !btn.contains(event.target)) {
          closeTooltip(matchingTooltip);
        }
      });
    });
  };

  const initStoreTooltips = () => {
    const openTooltip = (tooltip) => {
      tooltip.hidden = false;

      const rect = tooltip.getBoundingClientRect();

      if (rect.left + rect.width > window.innerWidth) {
        tooltip.classList.add('product__size-guide__tooltip--right');
      }
    };

    const closeTooltip = (tooltip) => {
      tooltip.hidden = true;
      tooltip.classList.remove('product__size-guide__tooltip--right');
    };

    storeTooltipsBtns.forEach((btn) => {
      const { index } = btn.dataset;
      const matchingTooltip = Array.from(storeTooltips).find((tooltip) => (
        tooltip.dataset.index === index
      ));

      btn.addEventListener('mouseenter', () => {
        openTooltip(matchingTooltip);
      });

      window.addEventListener('mouseover', (event) => {
        if (!matchingTooltip.contains(event.target) && !btn.contains(event.target)) {
          closeTooltip(matchingTooltip);
        }
      });
    });
  };

  const initForm = () => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      toggleAllAddToCartBtns(false);

      const variantId = variantSelect.value;

      // If size is not picked & size btn is disabled trigger "choose size" flow
      if (fitSizeAddToCartBtn.hasAttribute('hidden')) {
        fitSizeSelectionBtn.click();
        toggleAllAddToCartBtns(true);
        return;
      }

      addVariant({
        variantId,
        quantity: 1,
        callback: () => toggleAllAddToCartBtns(true),
      });
    });
  };

  const storeProduct = () => {
    const { handle } = productData;
    const handles = localStorage.getItem('viewedProducts')?.split(',') || [];

    if (handles.includes(handle)) {
      const index = handles.indexOf(handle);
      handles.splice(index, 1);
    }

    handles.unshift(handle);
    localStorage.setItem('viewedProducts', handles);
  };

  const initMobileCta = () => {
    // Show and hide mobile CTA
    const observer = new IntersectionObserver((entries) => {
      const rect = entries[0].boundingClientRect;
      const show = rect.y + rect.height < 0;

      mobileCta.classList[show ? 'add' : 'remove']('product__mobile-cta--active');
    });

    observer.observe(node);

    // Update mobile CTA top position based on header
    ctx.on('mobileHeader:scrolled', ({ mobileHeaderVisible }) => {
      mobileCta.classList[mobileHeaderVisible ? 'add' : 'remove']('product__mobile-cta--offset');
    });

    mobileCta.addEventListener('click', () => fitSizeSelectionBtn.click());
  };

  async function init() {
    if (prelaunch === false && isProductEvent === false) {
      await initVariantSelection();
      initOptionSelection();
      preselectOptions();
      initSizeGuide();
      initSizeGuideTooltips();
      initStoreTooltips();
      initForm();
    }

    if (isProductEvent === true) {
      initForm();
    }

    fitInfoBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      displayFitInfo();
    });

    initSwatches();
    initThumbnailDrawer();
    storeProduct();
    initMobileCta();

    node.dispatchEvent(new Event('loaded', { bubbles: true }));
  }

  /**
   * Init
   */
  await init();
});
